import * as React from 'react'
import {
  Form,
  Col,
  Select,
  Row,
  Table,
  Input,
  Tooltip,
  Button,
  Modal,
  Popconfirm,
  Spin,
  message,
} from 'antd'
import { Link } from 'react-router-dom'
import Layouts from '../components/Layouts'
import HomeInsurancePolicy from '../components/grid/HomeInsurancePolicy'
import {
  EditOutlined,
  CloseOutlined,
  EyeOutlined,
  UploadOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import ViewQuotation from './ViewQuotation'
import apiRequest from '../hooks/ApiRequest'
import hasPermissions from '../hooks/Permissions'
import { withRouter } from 'react-router-dom'

const productNameInLocalStorage = localStorage.getItem('productName')

class quotationList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchBox: null,
      quotationsNumberParams: this.props.match.params.quotationNumber,
      gotData: false,
      visible: false,
      visibleSearch: false,
      filterTable: null,
      baseData: [],
      name: '',
      viewQuotation: false,
      loading: true,
      productId: parseInt(localStorage.getItem('productId')),
      productname: localStorage.getItem('productName'),
      currentDate: new Date(),
      quotationPermissions: {},
      visibleUploadDocument: false,
      columns: [
        {
          key: '10',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: '20',
          title: 'Quotation Number',
          dataIndex: 'quotationnumber',
        },
        {
          key: '30',
          title: ' Policy Start Date',
          dataIndex: 'policystartdate',
        },
        {
          key: '40',
          title: ' Policy End Date',
          dataIndex: 'policyexpirytdate',
        },
        {
          key: '50',
          title: 'Annual Premium',
          dataIndex: 'grandtotalannualpremium',
        },
        {
          key: '51',
          title: 'Term Premium',
          dataIndex: 'grandtotaltermpremium',
        },
        {
          title: 'Actions',
          render: record => (
            <>
              {this.state.quotationPermissions.hasOwnProperty('12') && (
                <Tooltip title="Edit">
                  <button
                    className="edit_btn"
                    onClick={() => this.EditRecord(record.id)}>
                    <EditOutlined />
                  </button>
                </Tooltip>
              )}
              &nbsp;
              {this.state.quotationPermissions.hasOwnProperty('13') && (
                <Popconfirm
                  title="Are you sure to delete this record?"
                  onConfirm={() => this.deleteRecord(record.id)}>
                  <Tooltip title="Delete">
                    <Button type="danger">
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              )}
              &nbsp; &nbsp;
              {this.state.quotationPermissions.hasOwnProperty('14') && (
                <Tooltip title="View">
                  <Button
                    type="primary"
                    className="view_btn"
                    onClick={() => this.handleView(record.id)}>
                    <EyeOutlined />
                  </Button>
                </Tooltip>
              )}
            </>
          ),
        },
      ],
      columnsForFcp: [
        {
          key: '11',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: '21',
          title: 'Quotation Number',
          dataIndex: 'quotationnumber',
        },
        {
          key: '31',
          title: ' Policy Start Date',
          dataIndex: 'policystartdate',
        },
        {
          key: '41',
          title: 'Premium',
          dataIndex: 'proratatotaltermpremium',
          render: proratatotaltermpremium => {
            return parseFloat(proratatotaltermpremium).toFixed(2)
          },
        },

        {
          title: 'Actions',
          render: record => (
            <>
              {this.state.quotationPermissions.hasOwnProperty('12') && (
                <Tooltip title="Edit">
                  <button
                    className="edit_btn"
                    onClick={() => this.EditRecord(record.id)}>
                    <EditOutlined />
                  </button>
                </Tooltip>
              )}
              {this.state.quotationPermissions.hasOwnProperty('13') && (
                <Popconfirm
                  className="delete_btn"
                  title="Are you sure to delete this record?"
                  onConfirm={() => this.deleteRecord(record.id)}>
                  <Tooltip title="Delete">
                    <Button type="danger" >
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              )}
              &nbsp; &nbsp;
              {this.state.quotationPermissions.hasOwnProperty('14') && (
                <Tooltip title="View">
                  <Button
                    type="primary"
                    className="view_btn"
                    onClick={() => this.handleView(record.id)}>
                    <EyeOutlined />
                  </Button>
                </Tooltip>
              )}
            </>
          ),
        },
      ],
    }
    this.updateInput = this.updateInput.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.setVisible = this.setVisible.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.setVisibleSearch = this.setVisibleSearch.bind(this)
    this.EditRecord = this.EditRecord.bind(this)
    this.setVisibleFalse2 = this.setVisibleFalse2.bind(this)
    this.setVisibleUploadDocument = this.setVisibleUploadDocument.bind(this)
  }
  search = value => {
    const { baseData } = this.state

    const filterTable = baseData.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    this.setState({ filterTable })
  }
  // quotationList
  // componentDidMount() {

  //   // nothing need to change
  //  //let api = "https://localhost:7246/quotation/GetQuotaions/0,4"

  //   //Api call
  //   try{
  //     fetch(process.env.REACT_APP_BASE_URL+`/quotation/GetQuotaions/${10},${this.state.productId}`).then(res => res.json()).then(data => {
  //         this.setState({
  //           baseData: data.result,
  //           loading: false,
  //         })
  //       })
  //   }catch{
  //     console.log("An Error occured!");
  //   }

  // }
  fetchQuotations = async () => {
    this.setState({ loading: true })
    const response = await apiRequest(
      process.env.REACT_APP_BASE_URL +
      `/quotation/GetQuotaions/${this.state.productId}`,
      'GET',
    )
    if (response.success) {
      this.setState({ baseData: response?.data?.result, loading: false })
    } else {
      this.setState({ loading: false })
    }
  }
  componentDidMount() {
    const permissions = hasPermissions('Quotation')
    this.setState({ quotationPermissions: permissions }, () => {
      // console.log(
      //   'Saved Quotation permissions',
      //   this.state.quotationPermissions,
      // )
    })

    // nothing need to change
    //let api = "https://localhost:7246/quotation/GetQuotaions/0,4"
    this.fetchQuotations()
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.baseData !== prevState.baseData &&
      this.state.quotationsNumberParams
    ) {
      this.search(this.state.quotationsNumberParams)
    }
  }

  handleView(val) {
    localStorage.setItem('quotationId', val)
    this.setVisible2()
  }

  setVisible2() {
    this.setState({ viewQuotation: true })
  }
  setVisibleFalse2() {
    this.setState({ viewQuotation: false })
    localStorage.removeItem('quotationId')
    window.location.reload(false)
  }
  setVisibleUploadDocument(value) {
    this.setState({ visibleUploadDocument: value })
  }
  // deleteRecord(val) {
  //   fetch(
  //     process.env.REACT_APP_BASE_URL + '/quotation/DeleteQuotation/' + val+","+this.state.productId,
  //     {method: 'DELETE'},
  //   )
  //   message.success('Quotation Deleted Successfully !!')
  //   window.location.reload(false)
  // }

  deleteRecord = async (val) => {
    // debugger
      fetch(`${process.env.REACT_APP_BASE_URL}/quotation/DeleteQuotation/${val}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Delete successful:', data);
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });

    this.fetchQuotations();
  }

  EditRecord(val) {
    // this.setState({name:val});
    // // this.setState({startDate:});
    // // this.setState({endDate:});
    // this.setState({ visible: true });
    let quotationId = val
    this.setState({ uni: val })
    localStorage.setItem('clientId', val)
    window.location.href = `/layout/editquotation/${quotationId}`
    // nothing need to change
    // 'https://localhost:7246/quotation/GetQuotaionDetailsbyid/2
    //  window.location.href = 'https://localhost:7246/quotation/Addupdatequotation'
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        alert('asdsadsadsa')
      }
    })
  }

  // Functions for search functionality (if data not found)
  // Hide function to hide the modal after user clicked on cancel button
  hideModal() {
    this.setState({
      visibleSearch: false,
    })
  }

  // Redirecting to another model where client can add customer to the database
  setVisibleSearch() {
    this.setState({
      visibleSearch: false,
    })
    this.setState({ visible: true })
  }

  // Functions for Modal functioanlity to add customers
  setVisible() {
    alert('sadsasa')
  }
  setVisibleFalse() {
    this.setState({ visible: false })
  }

  // Functions for search functionality
  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    })
  }

  updateInput() {
    if (this.state.searchBox === 'Mayank') {
      alert('Data Found')
    } else {
      this.setState({
        visibleSearch: true,
      })
    }
  }

  render() {
    const { filterTable, baseData } = this.state
    return (
      <Layouts title="assets" classname="dashboard">
        <Spin
          className="loader-icon-fixed"
          spinning={this.state.loading}
          size="large"></Spin>
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  {' '}
                  {this.state.productname} QUOTATIONS{' '}
                </h3>
              </div>
            </Col>

            <Col xs={12} sm={24} md={24} lg={8}>
              <div className="item-search">
                <Form.Item>
                  {' '}
                  <Input.Search
                    placeholder="Search ..."
                    enterButton
                    onSearch={this.search}
                  />{' '}
                </Form.Item>
              </div>
            </Col>

            <Col xs={12} sm={24} md={24} lg={4}>
              {this.state.quotationPermissions.hasOwnProperty('11') && (
                <div className="create-quotation">
                  <Link to="/CreateQuotation" className="btn btn-primary" >
                    Create Quotation
                  </Link>
                </div>
              )}
              <Modal
                title="Add Customer"
                centered
                visible={this.state.visible}
                footer={null}
                onCancel={this.setVisibleFalse}
                width={1000}>
                <HomeInsurancePolicy parentToChild={this.state.name} />
              </Modal>
            </Col>
          </Row>
        </div>
        <div className="table-grid-bx">
          <Table
            rowKey={record => record.id}
            columns={
              this.state.productId === 3 || this.state.productId === 5
                ? this.state.columnsForFcp
                : this.state.columns
            }
            dataSource={filterTable == null ? baseData : filterTable}
            scroll={{ x: 768 }}
          />
        </div>
        <Modal
          title="Quotation Details"
          centered
          visible={this.state.viewQuotation}
          footer={null}
          onCancel={this.setVisibleFalse2}
          width={1000}>
          <ViewQuotation />
        </Modal>
      </Layouts>
    )
  }
}

const WrappedquotationList = Form.create({ name: 'normal_login' })(
  withRouter(quotationList),
)

export default WrappedquotationList
